export default __webpack_public_path__ + "static/media/Legguards of the Revelations of Tarim.8dba0555.jpg";